import { Building2 } from 'lucide-react';
import type { OnboardingIconProps } from './OnboardingIconProps';

const PREMIUM_STROKE = {
  strokeWidth: 1.25,
  absoluteStrokeWidth: true,
} as const;

/** Premium office building (Lucide Building2, tuned for onboarding) */
export function LawFirmRoleIcon({ className, ...props }: OnboardingIconProps) {
  return (
    <Building2
      className={className}
      aria-hidden
      {...PREMIUM_STROKE}
      {...props}
    />
  );
}
